import { ALLIANCE_APPS } from './alliance-apps';

/**
 * This repo's app: the per-app values the shared components read.
 */
export const CURRENT_APP = ALLIANCE_APPS.dashboard;

/**
 * Display fonts. DMD uses Roboto everywhere (Roboto Mono for IDs). The title
 * font applies to Sign In and System Screen headings.
 */
export const CURRENT_APP_FONTS = {
  nav: null,
  title: {
    fontFamily: 'Roboto, sans-serif',
    fontWeight: 400,
    textTransform: 'none',
  },
} as const;
